"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT_FOUND = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const hooks_1 = require("common/hooks");
const _404_gif_1 = __importDefault(require("assets/404.gif"));
const classes = __importStar(require("./NotFound.module.scss"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const root_1 = require("../root");
const index_1 = require("../index");
exports.NOT_FOUND = root_1.ROOT.sub("*", NotFound);
function NotFound() {
    const location = (0, react_router_dom_1.useLocation)();
    const isAdminPath = location.pathname.startsWith("/admin");
    const userPath = isAdminPath ? (0, index_1.resolveRoute)("ADMIN_HOME") : "/";
    const { formatMessage } = (0, hooks_1.useFormatter)();
    return (react_1.default.createElement("div", { className: "consumer-container" },
        react_1.default.createElement("section", null,
            react_1.default.createElement("div", { className: "hero-body", style: { paddingTop: "calc(50vh - 200px)" } },
                react_1.default.createElement("section", { className: `section ${classes.section}` },
                    react_1.default.createElement("div", { className: classes.columns },
                        react_1.default.createElement("div", { className: classes.column },
                            react_1.default.createElement("h1", { className: "title" }, formatMessage("NotFound.404")),
                            react_1.default.createElement("p", { className: "subtitle" }, formatMessage("NotFound.url", { url: location.pathname })),
                            react_1.default.createElement(react_router_dom_1.Link, { to: userPath, style: { padding: "30px 0", display: "block" } },
                                react_1.default.createElement(Button_1.default, null, formatMessage("NotFound.back")))),
                        react_1.default.createElement("div", { className: classes.column },
                            react_1.default.createElement("img", { src: _404_gif_1.default, alt: "404 error" }))))))));
}
exports.default = NotFound;
